module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARFJREFUOE/tlL9Kw1AYxX8n9RFiRyffwqXBWXBWIvpgopg6OejqZME/L2CaFnHpZhuHCipCTD8JarExqdhm0zvf73cu557viIqPKuYxBrq+rWXwBMKHgB5oNIvYGFj37RhY/4A8m9EFQiACruKmzsGcn4TKgBOPM6MVN+Ut+rYro5EJmYgEkYnQMW76gZ6yod8C9wTbeSsM9uNAO38d6G6ZJ1gqioqMu0Gg0/qmrViN5fwdpdwODnU54aG7YZ5UAnS+ACkAUgDM5bAsNv+//O7MXMEGVgVdg7aMjkEneeR6eKLhtE15ycpBIhplJeFwcX+gMxq2QEuv01roW33VUtr9hB5HSueqr1mGC5egKtAn5w1U9NUVuGa4ZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images2/win.png
// module id = IUBr
// module chunks = 2